import { Box } from "@mui/material";

const tabslist = [
  { label: "File Note",      value: "file note" },
  { label: "Fact Find",      value: "fact find", hidden: true },
  { label: "Powerpoint",     value: "powerpoint" },
  { label: "Documents",      value: "agreements" },
  { label: "Fact Find",  value: "factfind-ontology" },
  { label: "Email",      value: "email" },
  { label: "Skills",     value: "skill" },
];

const TabList = ({
  interactionTab,
  handleTabChange,
}: {
  interactionTab: number;
  handleTabChange: (event: React.SyntheticEvent, newValue: number) => void;
}) => {
  return (
    <Box
      sx={{
        ml: 0, p: 0,
        minWidth: 0, width: "100%",
        minHeight: 0, height: "100%",
        display: "flex", flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {/* Scrollable tab strip */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
          overflowX: "hidden",
          flex: 1,
          "&::-webkit-scrollbar": { width: 3 },
          "&::-webkit-scrollbar-thumb": { bgcolor: "#bbb", borderRadius: 2 },
        }}
      >
        {tabslist.map((tab, index) => (
          <Box
            key={index}
            onClick={() => handleTabChange({} as React.SyntheticEvent, index)}
            sx={{
              minWidth: 50, maxWidth: 50, width: 50,
              cursor: "pointer",
              display: tab.hidden ? "none" : "flex", alignItems: "center", justifyContent: "center",
              minHeight: 130, flexShrink: 0,
              transition: "all 0.2s ease",
              borderLeft:   interactionTab === index ? "2px solid #0070B9" : "1px solid #DFDFDF",
              borderTop:    interactionTab === index ? "2px solid #0070B9" : "1px solid #DFDFDF",
              borderBottom: interactionTab === index ? "2px solid #0070B9" : "1px solid #DFDFDF",
              borderRadius: "16px 0 0 16px",
              background: interactionTab === index ? "#E8F1FA" : "#F5F5F5",
              "&:hover": { background: interactionTab === index ? "#E8F1FA" : "#ECECEC" },
            }}
          >
            <Box
              sx={{
                transform: "rotate(-90deg)",
                whiteSpace: "nowrap",
                fontWeight: interactionTab === index ? "bold" : 500,
                color: interactionTab === index ? "#0070B9" : "#333",
                fontSize: { xs: "11px", lg: "12px" },
              }}
            >
              {tab.label}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default TabList;
